import React, { Component } from 'react';
import Col from 'react-bootstrap/Col';
import ListGroup from 'react-bootstrap/ListGroup';
import Row from 'react-bootstrap/Row';
import dateFormat from 'dateformat';

class CaseDetails extends Component {
  render() {
    return (
      <div>
        <Row>
          <Col lg={12}>
            <h5 className='text-center box title-box-secondary'>
              Case:
              <span className='case-number pl-2' />#
              {this.props.caseDetails.caseNumber}
            </h5>
            <h5 className='text-center box title-box-secondary'>
              Court:
              <span className='court-name pl-2' />
              {this.props.caseDetails?.courtFiledIn}
            </h5>
          </Col>
        </Row>
        <Row>
          <Col lg={6}>
            <article className='results-component order-info mt-3 mb-5'>
              <ListGroup variant='flush'>
                <h5 className='ml-3 mb-4 mt-3'>Identifiers</h5>
                <ListGroup.Item>
                  First Name:
                  <span className='pl-2'>
                    {this.props.caseDetails.caseIdentifiers?.firstName}
                  </span>
                </ListGroup.Item>
                <ListGroup.Item>
                  Middle Name:
                  <span className='pl-2'>
                    {this.props.caseDetails.caseIdentifiers.middleName}
                  </span>
                </ListGroup.Item>
                <ListGroup.Item>
                  Last Name:
                  <span className='pl-2'>
                    {this.props.caseDetails.caseIdentifiers.lastName}
                  </span>
                </ListGroup.Item>
                <ListGroup.Item>
                  Date of Birth:
                  <span className='pl-2'>
                    {dateFormat(this.props.caseDetails.caseIdentifiers.birthdate, "mmm dd yyyy")}
                  </span>
                </ListGroup.Item>
                  <ListGroup.Item>
                    Alias(es):
                    <span className='pl-2'>
                      {this.props.caseDetails.caseIdentifiers?.aliases ? this.props.caseDetails.caseIdentifiers?.aliases : "N/A"}
                    </span>
                  </ListGroup.Item>
                {this.props.caseDetails.caseIdentifiers?.ssn && <ListGroup.Item>
                  SSN:<span className='pl-2'>{this.props.caseDetails.caseIdentifiers?.ssn}</span>
                </ListGroup.Item>}
              </ListGroup>
            </article>
          </Col>
          <Col lg={6}>
            <article className='results-component subject-info mt-3 mb-5'>
              <ListGroup variant='flush'>
                <h5 className='ml-3 mb-4 mt-3'>Identity/Dates</h5>
                <ListGroup.Item>
                  Case Number:<span className='pl-2'>{this.props.caseDetails.caseNumber}</span>
                </ListGroup.Item>
                <ListGroup.Item>
                  File Date:<span className='pl-2'>{dateFormat(this.props.caseDetails?.offenseDate, "mmm dd yyyy")}</span>
                </ListGroup.Item>
                <ListGroup.Item>
                  Arrest Date:<span className='pl-2'>{dateFormat(this.props.caseDetails?.chargeDate, "mmm dd yyyy")}</span>
                </ListGroup.Item>
                <ListGroup.Item>
                  Offense Date:<span className='pl-2'>{dateFormat(this.props.caseDetails?.dispositionDate, "mmm dd yyyy")}</span>
                </ListGroup.Item>
              </ListGroup>
            </article>
          </Col>
        </Row>
      </div>
    );
  }
}

export default CaseDetails;
